module.exports = __webpack_public_path__ + "static/media/pin_glassdrive_highlighted.e3505383.png";